import { Box, Grid } from "@mui/material";
import { connect } from "react-redux";
import { useEffect } from "react";
import moment from "moment";

const InventoryReview = ({
    formObj,
    makeList,
    modelList,
    bodyList,
    licenseCategoryList,
    inventoryStockStatuses,
}) => {
    // const stockStatusOptions = (Array.isArray(inventoryStockStatuses)
    //     ? inventoryStockStatuses
    //     : Array.isArray(inventoryStockStatuses?.data)
    //         ? inventoryStockStatuses.data
    //         : inventoryStockStatuses?.data?.inventoryStockStatuses
    //         || inventoryStockStatuses?.data?.erp_stock_statuses
    //         || inventoryStockStatuses?.inventoryStockStatuses
    //         || []).filter((status) => {
    //             const value = String(status?.value ?? status?.label ?? '').toLowerCase();
    //             const label = String(status?.label ?? status?.value ?? '').toLowerCase();
    //             return !['unpublished', 'void'].includes(value) && !['unpublished', 'void'].includes(label);
    //         });
    const filterModelList = formObj?.vehicle?.bike_make_id
        ? makeList.find((make) => make.id === formObj?.vehicle?.bike_make_id)?.models
        : modelList;
    const filterColorList = filterModelList?.find(
        (item) => item?.id === formObj?.vehicle?.bike_model_id
    )?.colours || [];
    const colorName = filterColorList.length > 0
        ? filterColorList.find((color) => color.id === formObj?.vehicle?.bike_model_colour_id)?.name || formObj?.vehicle?.color
        : formObj?.vehicle?.colour_text;
    // const selectedStockStatus = stockStatusOptions.find(
    //     (item) => String(item?.value) === String(formObj?.vehicle?.stock_status)
    // );

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    return (
        <Box mt={3}>
            <Grid container spacing={2}>
                {formObj?.inventory_type === "used" &&
                    <>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <div className="text-bold">Owner Name</div>
                            <div>{formObj?.vehicle?.owner_name || "-"}</div>
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <div className="text-bold">Email Address</div>
                            <div>{formObj?.vehicle?.email || "-"}</div>
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <div className="text-bold">Phone Number</div>
                            <div>+65{formObj?.vehicle?.phone || "-"}</div>
                        </Grid>
                    </>
                }

                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="text-bold">Make / Model</div>
                    <div>{formObj?.vehicle?.make || "-"} / {formObj?.vehicle?.model || "-"}</div>
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="text-bold">Type</div>
                    <div>{formObj?.inventory_type === "new" ? "New Motorcycle" : formObj?.inventory_type === "used" ? "Used Motorcycle" : "For Rent"}</div>
                </Grid>

                {formObj?.inventory_type !== "new" &&
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <div className="text-bold">Registration No.</div>
                        <div>{formObj?.vehicle?.reg_no || "-"}</div>
                    </Grid>}
                {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="text-bold">Revision</div>
                    <div>{formObj?.vehicle?.revision || "-"}</div>
                </Grid> */}

                {formObj?.inventory_type !== "used" && (
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <div className="text-bold">Primary Colour</div>
                        <div>{colorName || "-"}</div>
                    </Grid>
                )}
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="text-bold">Body Type</div>
                    <div>
                        {Array.isArray(formObj?.vehicle?.body_type) && formObj?.vehicle?.body_type.length > 0
                            ? formObj.vehicle.body_type.map((item) => bodyList?.find((body) => body.id === item)?.name).join(", ")
                            : formObj?.vehicle?.body_type || "-"}
                    </div>
                </Grid>

                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="text-bold">License Category</div>
                    <div>{formObj?.vehicle?.license_category_id
                        ? licenseCategoryList.find((item) => item.id === formObj?.vehicle?.license_category_id)?.name
                        : "-"}</div>
                </Grid>

                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="text-bold">Year of Manufacture</div>
                    <div>{formObj?.vehicle?.manu_year || "-"}</div>
                </Grid>
                {formObj?.inventory_type === "used" &&
                    <>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <div className="text-bold">Registration Date</div>
                            <div>{formObj?.vehicle?.reg_date ? moment(formObj.vehicle.reg_date, "YYYY-MM-DD").format("DD MMM YYYY") : "-"}</div>
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <div className="text-bold">COE Expiry Date</div>
                            <div>{formObj?.vehicle?.coe_expiry ? moment(formObj.vehicle.coe_expiry, "YYYY-MM-DD").format("DD MMM YYYY") : "-"}</div>
                        </Grid>
                    </>}

                {formObj?.inventory_type !== "new" &&
                    <>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <div className="text-bold">Mileage</div>
                            <div>{formObj?.vehicle?.mileage || "-"}</div>
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <div className="text-bold">No. of Previous Owner</div>
                            <div>{formObj?.vehicle?.no_of_owner || "-"}</div>
                        </Grid>
                    </>}

                {formObj?.inventory_type !== "rental" ? (
                    <>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <div className="text-bold">Purchase Price</div>
                            <div>${Number(formObj?.pricing?.purchase_price)?.toLocaleString() || "-"}</div>
                        </Grid>
                        {formObj?.inventory_type !== "used" && (
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <div className="text-bold">ARF</div>
                                <div>${Number(formObj?.pricing?.arf)?.toLocaleString() || "-"}</div>
                            </Grid>
                        )}
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <div className="text-bold">Suggested Price</div>
                            <div>${Number(formObj?.pricing?.suggested_price)?.toLocaleString() || "-"}</div>
                        </Grid>
                    </>
                ) :
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <div className="text-bold">Rental Pricing</div>
                        <ul style={{ padding: 5, paddingInline: 18 }}>
                            <li>${Number(formObj?.pricing?.daily_rate)?.toLocaleString() || '-'} per day</li>
                            <li>${Number(formObj?.pricing?.weekend_rate)?.toLocaleString() || '-'} for Weekend</li>
                            <li>${Number(formObj?.pricing?.three_day_rate)?.toLocaleString() || '-'} for 3 Days</li>
                            <li>${Number(formObj?.pricing?.weekly_rate)?.toLocaleString() || '-'} Weekly</li>
                            <li>${Number(formObj?.pricing?.monthly_rate)?.toLocaleString() || '-'} Monthly</li>
                        </ul>
                    </Grid>}

                {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="text-bold">Stock Status</div>
                    <div>{selectedStockStatus?.label || "-"}</div>
                </Grid> */}
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className="text-bold">Internal Remarks</div>
                    <div>{formObj?.vehicle?.internal_remarks || "-"}</div>
                </Grid>
            </Grid>
        </Box>
    );
};

function mapStateToProps({ General }) {
    return {
        makeList: General.bike_makes,
        modelList: General.bike_models,
        bodyList: General.bike_types,
        licenseCategoryList: General.license_categories,
    };
}

export default connect(mapStateToProps)(InventoryReview);
